import React from 'react';
import {Divider, Toggle} from 'material-ui';
import ConstValues from 'utils/const';
import SearchFieldsActions from 'actions/search/SearchFieldsActions';
import PhoneNumberSearchWidget, {
  PHONE_NUMBER_FLEX_DIV_SIDEBAR_CSS_NAME,
} from 'components/pure/utils/phone/PhoneNumberSearchWidget';
import cn from 'classnames';
import {getSearchFieldClass} from 'components/stateful/search/getSearchFieldClass';

export default class PhoneNumberSidebarSearchWidget extends React.PureComponent {
  /**
   * This callback function gets called when a `PhoneNumber` search field is
   * toggled on or off by a user. It triggers various actions to update the
   * search expression and state
   * @param event {object}
   * @param toggled {boolean}
   */
  onToggleStringSearchField = (event, toggled) => {
    SearchFieldsActions.updateSearchWidgetToggleState(
      ConstValues.phoneWidgetType,
      toggled,
      this.props.searchField
    );

    setTimeout(() => {
      SearchFieldsActions.updateStringSearchExpression(this.props.searchField, toggled);
    }, ConstValues.delayDurationForSearchWidgetToggles);

    if (toggled) {
      this.props.updateLastToggledOnSearchWidget(this.props.searchField.name);
    }
  };

  /**
   * <PhoneNumberSearchWidget/> initiated search term change w.r.t. the phone
   * number field. Similar to other sidebar search widgets, we need to inform
   * the search fields store the search term for the phone number search field
   * changed.
   * @param searchTerm {string}
   */
  handleUserInitiatedSearchAction = searchTerm => {
    SearchFieldsActions.updatePhoneSearchField(this.props.searchField, searchTerm);
  };

  /**
   * Render a sidebar search widget container for the phone number with the name
   * of the phone search field and the toggle
   */
  render() {
    const classes = cn('phone-search-widget', getSearchFieldClass(this.props.searchField.name));
    return (
      <div className={classes}>
        <Toggle
          label={this.props.searchField.name}
          defaultToggled={false}
          onToggle={this.onToggleStringSearchField}
          toggled={this.props.toggled}
        />
        <Divider style={{marginTop: '5px'}} />
        {this.props.toggled ? (
          <div>
            <p>Enter the parts of the phone number you know.</p>
            <PhoneNumberSearchWidget
              className={'search-input-phone-number-widget'}
              onSearchTermChange={this.handleUserInitiatedSearchAction}
              flexDivClassname={PHONE_NUMBER_FLEX_DIV_SIDEBAR_CSS_NAME}
            />
          </div>
        ) : null}
      </div>
    );
  }
}
